import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AuthenticationService } from 'src/app/auth/authentication.service'
import { auth } from 'firebase/app';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  public selected = false;
  currentLink = 0;

  constructor(public auth: AngularFireAuth, private authenticationService: AuthenticationService) { 

  }

  selectedLink(){
    if (this.currentLink == 0)
      return this.selected = true;
  }
  
  
  ngOnInit() {
  }

  logout() {
    console.log('logging out')
    this.authenticationService.SignOut()
  }

}
